
import OBase from './OBase';
import * as Geometry from '../geometry';

export default class UnitVector extends OBase {
  update () {
    let valTree = this.getVector3Input('Vector', false);
    let output = this.getGenericObjectOutput('Vector');

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        var val = valTree.branches[i][j];
        var nval = new THREE.Vector3(val.x, val.y, val.z);
        nval.normalize();
        outTree.add(nval, valTree.paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/UnitVector.js